import { Button } from "components/Button";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import React from "react";
import { 
  Container,
  ContainerTable, 
  TableContent, 
  ContainerLoading,
} from './styles';

interface RowsPerPageProps {
  label:string,
  value:string,
}

interface TableModifiedTableProps {
  headerColumns: string[],
  rows: Object[],
  paginate?:boolean,
  totalItemsCount?:number,
  pageNumber?:number,
  rowsPerPage?:string,
  rowsPerPageOptions?:RowsPerPageProps[],
  onClearFilters?: () => void,
  onRowsPerPageChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void
  onPageSelected?: (pageNumber: number) => void,
  onRowClick?: (row: any, rowIndex: number) => void,
}

export const TableModifiedTable:React.FC<TableModifiedTableProps> = ({
  headerColumns,
  rows,
  totalItemsCount,
  rowsPerPage='10',
  onClearFilters,
  onRowClick,
}) => {
  const totalPages = Math.ceil((totalItemsCount ?? 0)/parseInt(rowsPerPage));

  return (
    <Container>
      {
        rows.length == 0
        ? <ContainerLoading>
            <PlaceHolderNotExists title="Não encontramos resultados para os filtros aplicados"/>
            <Button 
              label="Limpar busca" 
              typeBtn="blue"
              block={false} 
              onClick={onClearFilters}
            />
          </ContainerLoading>
        : <ContainerTable>
            <TableContent>
              <thead>
                <tr>
                  {
                    headerColumns.map((item, index) => <th key={index}>{item}</th>)
                  }
                </tr>
              </thead>
              <tbody>
                {
                  rows.map((row, index) => (
                    <tr key={index} onClick={() => onRowClick && onRowClick(row, index)} style={{ cursor: onRowClick ? 'pointer' : undefined }}>
                      {
                        Object.values(row).map((value, index) => (
                          <td key={index}>
                            {value}
                          </td>
                        ))
                      }
                    </tr>
                  ))
                }
              </tbody>
            </TableContent>
          </ContainerTable>
      }
    </Container>
  )
}